export default "__VITE_ASSET__BIlkFqnB__"